import { render, staticRenderFns } from "./paperInvigilationDetail.vue?vue&type=template&id=6ca551be&scoped=true"
import script from "./paperInvigilationDetail.vue?vue&type=script&lang=js"
export * from "./paperInvigilationDetail.vue?vue&type=script&lang=js"
import style0 from "./paperInvigilationDetail.vue?vue&type=style&index=0&id=6ca551be&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca551be",
  null
  
)

export default component.exports